/**
 * 媒体替换工具
 * 功能：
 * 1. 根据视频链接列表替换视频封面图片
 * 2. 根据图片链接列表替换图片地址
 */

(function() {
  'use strict';

  // ========== 配置区域 ==========
  // 请在这里配置你的视频链接列表和对应的封面图片
  // 格式: { videoUrl: '封面图片URL' }
  const pcImg='https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Video_restricted_pc.png?v=1766649962';
  const mbImg='https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Video_restricted_mb.png?v=1766649962';
  const VIDEO_COVER_MAP = {
    // 示例：
    // 'https://example.com/video1.mp4': 'https://example.com/cover1.jpg',
    // 'https://example.com/video2.mp4': 'https://example.com/cover2.jpg',
    'https://cdn.shopify.com/videos/c/o/v/df298dc664234bc5af2e5ebf019ff5b1.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/563a3e11b4fd44cba1db87ba6a79dc16.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/16b045d8a6924b67a7aa488f09a6e566.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/ebf7824d39a44722ab6d02458434d056.mov':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/cdf37fe3c86a4dd386c9c60e73709318.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/5894b5a9a25f4377b253d904319128ad.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/24872722299244ecbd598fe2de264a88.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/4d0e5b39a56c4ec9a5509f7335e99aeb.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/4dafee1d59cd439582c87db701f9a9eb.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/5537dd598eae45a78026688a1c5e03a1.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/6ecf08e8bba94425af2a0ca6db98e9cd.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/2a9d29a7fef54248827c14856d378449.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/15a21171a73d478e804ffad42aeafd92.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/eb4eb70984d64707a285d186dfdabab7.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/16b045d8a6924b67a7aa488f09a6e566.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/7772dd9f55674922962032e3d19aed83.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/6170221f618d4054bddbc2f796563718.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/50c0a9cd3aa147a3b9b2e1f79b833413.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/ac994cef655d4729a021ed5307741a39.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/ac994cef655d4729a021ed5307741a39.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/cd9f676edc9643239aec0b66f4816e6a.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/f60ef4311ed74cfab9345523ba58d7e4.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/87cf45b5677f49b8b6d510acc187cc65.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/56fedbc2fcc64699a79387651d73d4d2.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/3645339e4f59476ea1b429466da15982.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/5092715820e442e8a3a6b77d58c16afa.mp4':mbImg,
    'https://cdn.shopify.com/videos/c/o/v/cb4650f0c4454b98af61fb9bae3491d4.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/05023f3b27654d74ace78eff81b33120.mp4':pcImg,
    'https://cdn.shopify.com/videos/c/o/v/352cd1f22fbb4cdda591ac809d6be600.mp4':pcImg,
  };
  const judgemeImg='https://cdn.shopify.com/s/files/1/0661/6059/1091/files/1764888611__img_4163__original_V2.png?v=1766729411';
  // 请在这里配置图片替换映射
  // 格式: { '原图片URL': '新图片URL' }
  const IMAGE_REPLACE_MAP = {
    // 示例：
    // 'https://example.com/image1.jpg': 'https://example.com/image1_v2.jpg',
    // 'https://example.com/image2.png': 'https://example.com/image2_v2.png',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Soft1.png?v=1762133370':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Soft1_V2.jpg?v=1766715442',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/sst_desc_m_2.png?v=1761815767':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Soft1_V2.jpg?v=1766715442',
    'https://www.zelexdoll.com/cdn/shop/files/my--konw-1-pc_2x_1f129fb1-fcf1-4dac-b781-087fb7089d8a.png?v=1753926230&width=1000':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/my--konw-1-pc_2x_1f129fb1-fcf1-4dac-b781-087fb7089d8a_V2.png?v=1766717689',
    'https://www.zelexdoll.com/cdn/shop/files/2_f3393b30-b8cf-4ce6-91e9-79e18809ab0b.jpg?v=1745481878':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/2_f3393b30-b8cf-4ce6-91e9-79e18809ab0b_V2.png?v=1766717806',
    'https://www.zelexdoll.com/cdn/shop/files/users_stories-2-pc_2x_2d890362-3112-4a0b-b52a-9aafadc45a2c.png?v=1753865988':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/users_stories-2-pc_2x_2d890362-3112-4a0b-b52a-9aafadc45a2c_V2.png?v=1766717946',
    'https://www.zelexdoll.com/cdn/shop/files/54f7d153f0ce512bc0fc3f0e4a4cfdf3.jpg?v=1744904034&width=900':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/54f7d153f0ce512bc0fc3f0e4a4cfdf3_V2.png?v=1766726485',
    'https://www.zelexdoll.com/cdn/shop/files/a6b6a0e879600d633d453f2c465399fc.jpg?v=1744904033&width=900':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/a6b6a0e879600d633d453f2c465399fc_V2.png?v=1766726485',
    'https://www.zelexdoll.com/cdn/shop/files/2_bd4dcd23-cd13-40a0-924a-a1394d2d166a.jpg?v=1744902565&width=900':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/2_bd4dcd23-cd13-40a0-924a-a1394d2d166a_V2.png?v=1766726484',
    'https://www.zelexdoll.com/cdn/shop/files/1_bdaf0f5e-c277-403f-8625-caf4a787bd76.jpg?v=1744904034&width=900':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/1_bdaf0f5e-c277-403f-8625-caf4a787bd76_V2.png?v=1766726485',
    'https://www.zelexdoll.com/cdn/shop/files/2_e8ed73a0-176d-4bcb-b13f-d38d7b478e6d.jpg?v=1744904033&width=750':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/2_e8ed73a0-176d-4bcb-b13f-d38d7b478e6d_V2.png?v=1766726484',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/influencer.png?v=1763106125':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Influencer_Banner_3840-2160.jpg?v=1766733803',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/1_-Non_Standing.jpg?v=1763011531':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/1_-Non_Standing_V2.jpg?v=1766718864',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/2_-Standing_With_Bolts.jpg?v=1763011531':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/2_-Standing_With_Bolts_V2.png?v=1766718580',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3_-Standing_Without_Bolts.jpg?v=1763011532':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3_-Standing_Without_Bolts_V2.jpg?v=1766718862',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/importedImage528b960a-0b3a-4de2-af15-80ac0ca9d75d.avif?v=1756204639':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/importedImage528b960a-0b3a-4de2-af15-80ac0ca9d75d_V2.png?v=1766718035',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/sei_6716903.webp?v=1756204628':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/sei_6716903_V2.png?v=1766718104',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/material2.png?v=1756778860':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/material2_V2.png?v=1766727494',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/factory.png?v=1756278101':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/factory_V2.png?v=1766726485',
    'https://www.zelexdoll.com/cdn/shop/files/Rectangle_Copy_2x_1_da413a99-a685-4dbb-b651-fa7559dc48f0.png?v=1746780799':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Rectangle_Copy_2x_1_da413a99-a685-4dbb-b651-fa7559dc48f0_V2.png?v=1766721218',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3_5b838f6b-1ad3-4f5d-8878-f44c7ad164e5.png?v=1744702311':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3_5b838f6b-1ad3-4f5d-8878-f44c7ad164e5_V2.png?v=1766721384',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/4._Wrap-1_5185c53a-e726-4c57-8586-c72ae2fca8f5.jpg?v=1744698385':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/4._Wrap-1_5185c53a-e726-4c57-8586-c72ae2fca8f5_V2.jpg?v=1766719813',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3._Soft-1_82582fd5-9ea7-4895-82a0-18f94ccad65d.jpg?v=1744698384':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Nipple.jpg?v=1766738214',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3_032fb9e3-5def-4bd3-a0e9-31120202800e.jpg?v=1742269572':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3_032fb9e3-5def-4bd3-a0e9-31120202800e_V2.jpg?v=1766720459',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/6_4dbbc6bf-d108-4378-bd81-9b21d5292da9.jpg?v=1750302953':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/6_4dbbc6bf-d108-4378-bd81-9b21d5292da9_V2.jpg?v=1766720408',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/5_e66d43e1-2097-4543-a25a-0788bb5cb26b.jpg?v=1742269627':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/5_e66d43e1-2097-4543-a25a-0788bb5cb26b_V2.jpg?v=1766720344',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/4_58866b4f-7bb7-4fd3-ab74-eda2687be8f2.jpg?v=1742269626':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/4_58866b4f-7bb7-4fd3-ab74-eda2687be8f2_V2.png?v=1766720230',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/1_1_43f903ac-29e6-4c6c-a421-e0ee87020a9c.jpg?v=1750234205':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/1_1_43f903ac-29e6-4c6c-a421-e0ee87020a9c_V2.png?v=1766721218',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/ZELEX-Inspriation_Series_Banner-2_fbd1da59-224e-4c64-bc6c-2e4e2b2df421.jpg?v=1750303993':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/ZELEX-Inspriation_Series_Banner-2_fbd1da59-224e-4c64-bc6c-2e4e2b2df421_V2.png?v=1766725462',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3._Soft-1_7efdc8b4-c1a6-48e7-bc88-1d8e44d2cc94.jpg?v=1742276540':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/Soft1_V2.jpg?v=1766715442',
    'https://dollforum.com/forum/download/file.php?id=1198946&t=1':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/4._Wrap-1_5185c53a-e726-4c57-8586-c72ae2fca8f5_V2.jpg?v=1766719813',
    'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/ZELEX-Inspriation_Series_Banner-4.jpg?v=1742270136':'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/3_5b838f6b-1ad3-4f5d-8878-f44c7ad164e5_V2.png?v=1766721384',
    'https://judgeme.imgix.net/zelexdoll/1764888611__img_4163__original.jpeg?auto=format&w=160':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764888611__img_4163__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764888624__img_3470__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764888624__img_3470__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764887732__img_4180__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764887732__img_4180__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764887355__img_4116__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764887355__img_4116__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764886846__img_3750__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764886846__img_3750__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764886214__img_3592__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1764886214__img_3592__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1759126000__0__cmwAPypf__picture3-1__original.png?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1759126000__0__cmwAPypf__picture3-1__original.png?auto=format&w=160':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1748596415__1748596411529-673be208-5c75-4dcf-a097-d8__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1748596415__1748596411529-673be208-5c75-4dcf-a097-d8__original.jpeg?auto=format&w=160':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388508__1747388497987-a2__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388508__1747388497987-a2__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388509__1747388504262-a2__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388509__1747388504262-a2__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388673__1747388658814-2db4cbbc-1a8e-4949-a8a2-f5__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388673__1747388658814-2db4cbbc-1a8e-4949-a8a2-f5__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388674__1747388665879-img_9845__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388675__1747388669288-img_9848-1__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388836__1747388829128-hq01__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388836__1747388829128-hq01__original.jpeg?auto=format':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388837__1747388832004-hq02__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388837__1747388832004-hq02__original.jpeg?auto=format&w=160':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388838__1747388835202-sim1__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388838__1747388835202-sim1__original.jpeg?auto=format&w=160':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388879__1747388875377-dsc_5821__original.jpeg?auto=format&w=1024':judgemeImg,
    'https://judgeme.imgix.net/zelexdoll/1747388879__1747388875377-dsc_5821__original.jpeg?auto=format&w=160':judgemeImg
  };

  // ========== 核心功能函数 ==========

  /**
   * 替换视频封面
   */
  function replaceVideoCovers() {
    // 查找所有 video 标签
    const videos = document.querySelectorAll('video');
    
    videos.forEach(video => {
      // 检查 video 的 src 或 source 标签
      let videoUrl = video.src;
      
      // 如果没有 src，检查 source 标签
      if (!videoUrl) {
        const source = video.querySelector('source');
        if (source) {
          videoUrl = source.src;
        }
      }

      // 如果找到了视频 URL，检查是否在列表中
      if (videoUrl) {
        // 尝试精确匹配和部分匹配
        const matchedKey = Object.keys(VIDEO_COVER_MAP).find(key => {
          return videoUrl.includes(key) || key.includes(videoUrl);
        });

        if (matchedKey && VIDEO_COVER_MAP[matchedKey]) {
          // 检查视频是否在 my-video-container 内
          const videoContainer = video.closest('.my-video-container');
          
          if (videoContainer) {
            // 特殊处理：在 my-video-container 内的视频
            const videoCover = videoContainer.querySelector('.video-cover');
            
            if (videoCover && !videoCover.dataset.replaced) {
              // 标记为已替换，避免重复处理
              videoCover.dataset.replaced = 'true';
              
              // 移除点击事件
              videoCover.removeAttribute('onclick');
              videoCover.style.cursor = 'default';
              videoCover.style.pointerEvents = 'none';
              
              // 移除播放按钮
              const playButton = videoCover.querySelector('.video-play-div');
              if (playButton) {
                playButton.style.display = 'none';
              }
              
              // 替换 cover-image 的 src
              const coverImage = videoCover.querySelector('.cover-image');
              if (coverImage) {
                // 先清空原图片地址
                coverImage.src = '';
                coverImage.removeAttribute('src');
                requestAnimationFrame(function() {
                  coverImage.src = VIDEO_COVER_MAP[matchedKey];
                  coverImage.style.width = '100%';
                  coverImage.style.height = '100%';
                  coverImage.style.objectFit = 'cover';
                });
              } else {
                // 如果没有 cover-image，创建一个新的 img 元素
                const newImg = document.createElement('img');
                newImg.className = 'cover-image';
                newImg.src = VIDEO_COVER_MAP[matchedKey];
                newImg.style.width = '100%';
                newImg.style.height = '100%';
                newImg.style.objectFit = 'cover';
                newImg.alt = 'video cover';
                
                // 清空 video-cover 内容并添加新图片
                videoCover.innerHTML = '';
                videoCover.appendChild(newImg);
              }
            }
          } else {
            // 普通处理：将 video 元素替换为图片
            if (!video.dataset.replaced && video.parentNode) {
              // 先清空视频地址，阻止加载
              video.src = '';
              video.removeAttribute('src');
              const sources = video.querySelectorAll('source');
              sources.forEach(source => {
                source.src = '';
                source.removeAttribute('src');
              });
              
              video.dataset.replaced = 'true';
              
              // 创建新的 img 元素
              const newImg = document.createElement('img');
              newImg.src = VIDEO_COVER_MAP[matchedKey];
              newImg.alt = video.getAttribute('alt') || 'video cover';
              
              // 复制 video 的样式和类名
              if (video.className) {
                newImg.className = video.className;
              }
              if (video.id) {
                newImg.id = video.id;
              }
              
              // 复制内联样式
              if (video.style.cssText) {
                newImg.style.cssText = video.style.cssText;
              }
              
              // 确保图片样式
              newImg.style.width = video.style.width || '100%';
              newImg.style.height = video.style.height || 'auto';
              newImg.style.objectFit = 'cover';
              newImg.style.display = video.style.display || 'block';
              
              // 替换 video 元素
              video.parentNode.replaceChild(newImg, video);
            }
          }
        }
      }

      // 检查 data-src 属性（懒加载场景）
      const dataSrc = video.getAttribute('data-src');
      if (dataSrc) {
        const matchedKey = Object.keys(VIDEO_COVER_MAP).find(key => {
          return dataSrc.includes(key) || key.includes(dataSrc);
        });

        if (matchedKey && VIDEO_COVER_MAP[matchedKey]) {
          // 检查视频是否在 my-video-container 内
          const videoContainer = video.closest('.my-video-container');
          
          if (videoContainer) {
            // 特殊处理：在 my-video-container 内的视频
            const videoCover = videoContainer.querySelector('.video-cover');
            
            if (videoCover && !videoCover.dataset.replaced) {
              videoCover.dataset.replaced = 'true';
              videoCover.removeAttribute('onclick');
              videoCover.style.cursor = 'default';
              videoCover.style.pointerEvents = 'none';
              
              const playButton = videoCover.querySelector('.video-play-div');
              if (playButton) {
                playButton.style.display = 'none';
              }
              
              const coverImage = videoCover.querySelector('.cover-image');
              if (coverImage) {
                coverImage.src = VIDEO_COVER_MAP[matchedKey];
              }
            }
          } else {
            // 普通处理：将 video 元素替换为图片
            if (!video.dataset.replaced && video.parentNode) {
              // 先清空视频地址，阻止加载
              video.src = '';
              video.removeAttribute('src');
              const sources = video.querySelectorAll('source');
              sources.forEach(source => {
                source.src = '';
                source.removeAttribute('src');
              });
              
              video.dataset.replaced = 'true';
              
              // 创建新的 img 元素
              const newImg = document.createElement('img');
              newImg.src = VIDEO_COVER_MAP[matchedKey];
              newImg.alt = video.getAttribute('alt') || 'video cover';
              
              // 复制 video 的样式和类名
              if (video.className) {
                newImg.className = video.className;
              }
              if (video.id) {
                newImg.id = video.id;
              }
              
              // 复制内联样式
              if (video.style.cssText) {
                newImg.style.cssText = video.style.cssText;
              }
              
              // 确保图片样式
              newImg.style.width = video.style.width || '100%';
              newImg.style.height = video.style.height || 'auto';
              newImg.style.objectFit = 'cover';
              newImg.style.display = video.style.display || 'block';
              
              // 替换 video 元素
              video.parentNode.replaceChild(newImg, video);
            }
          }
        }
      }
    });

    // 查找所有 iframe（可能包含视频）
    // 先尝试匹配已知的视频平台，然后检查所有 iframe 的 src 是否匹配 VIDEO_COVER_MAP
    const allIframes = document.querySelectorAll('iframe');
    
    // 辅助函数：提取 URL 的基础路径（去掉查询参数和哈希）
    function getBaseUrl(url) {
      try {
        const urlObj = new URL(url);
        return urlObj.origin + urlObj.pathname;
      } catch (e) {
        // 如果不是完整 URL，尝试手动处理
        const parts = url.split('?')[0].split('#')[0];
        return parts;
      }
    }
    
    // 辅助函数：检查两个 URL 是否匹配
    function urlMatches(url1, url2) {
      const base1 = getBaseUrl(url1);
      const base2 = getBaseUrl(url2);
      return base1 === base2 || base1.includes(base2) || base2.includes(base1);
    }
    
    allIframes.forEach(iframe => {
      const iframeSrc = iframe.src || iframe.getAttribute('src') || '';
      
      // 跳过空 src 或明显不是视频的 iframe
      if (!iframeSrc || (!iframeSrc.includes('video') && !iframeSrc.includes('.mp4') && 
          !iframeSrc.includes('.mov') && !iframeSrc.includes('youtube') && 
          !iframeSrc.includes('vimeo') && !iframeSrc.includes('cdn.shopify.com/videos'))) {
        return;
      }
      
      // 改进的匹配逻辑：先尝试精确匹配，再尝试部分匹配
      const matchedKey = Object.keys(VIDEO_COVER_MAP).find(key => {
        // 提取基础 URL 进行比较
        return urlMatches(iframeSrc, key);
      });

      if (matchedKey && VIDEO_COVER_MAP[matchedKey]) {
        // 将 iframe 替换为图片（即使已经有 data-cover-applied，也要替换）
        if (!iframe.dataset.replaced && iframe.parentNode) {
          iframe.dataset.replaced = 'true';
          
          // 创建新的 img 元素
          const newImg = document.createElement('img');
          newImg.src = VIDEO_COVER_MAP[matchedKey];
          newImg.alt = iframe.getAttribute('title') || iframe.getAttribute('alt') || 'video cover';
          
          // 复制 iframe 的样式和类名
          if (iframe.className) {
            newImg.className = iframe.className;
          }
          if (iframe.id) {
            newImg.id = iframe.id;
          }
          
          // 复制内联样式（但移除背景图片相关样式）
          if (iframe.style.cssText) {
            const styleText = iframe.style.cssText
              .replace(/background-image[^;]*;?/gi, '')
              .replace(/background-size[^;]*;?/gi, '')
              .replace(/background-position[^;]*;?/gi, '');
            if (styleText.trim()) {
              newImg.style.cssText = styleText;
            }
          }
          
          // 确保图片样式
          newImg.style.width = iframe.style.width || iframe.getAttribute('width') || '100%';
          newImg.style.height = iframe.style.height || iframe.getAttribute('height') || 'auto';
          newImg.style.objectFit = 'cover';
          newImg.style.display = iframe.style.display || 'block';
          
          // 复制其他属性
          if (iframe.getAttribute('title')) {
            newImg.setAttribute('title', iframe.getAttribute('title'));
          }
          
          // 替换 iframe 元素
          iframe.parentNode.replaceChild(newImg, iframe);
        }
      }
    });
  }

  /**
   * 替换图片地址
   */
  function replaceImages() {
    // 辅助函数：规范化 URL（处理协议相对 URL、HTML 实体编码等）
    function normalizeUrl(url) {
      if (!url) return url;
      
      // 解码 HTML 实体（&amp; -> &）
      url = url.replace(/&amp;/g, '&');
      
      // 处理协议相对 URL（//example.com -> https://example.com）
      if (url.startsWith('//')) {
        url = 'https:' + url;
      }
      
      return url;
    }
    
    // 辅助函数：提取 URL 的路径和查询参数部分（忽略域名和协议）
    function getPathAndQuery(url) {
      if (!url) return url;
      
      try {
        const normalized = normalizeUrl(url);
        const urlObj = new URL(normalized);
        // 返回路径和查询参数（不包含域名和协议）
        return urlObj.pathname + urlObj.search;
      } catch (e) {
        // 如果解析失败，尝试手动提取
        const normalized = normalizeUrl(url);
        // 移除协议和域名部分
        const match = normalized.match(/\/\/[^\/]+(\/.*)/);
        if (match) {
          return match[1];
        }
        // 如果已经是路径，直接返回
        if (normalized.startsWith('/')) {
          return normalized;
        }
        return normalized;
      }
    }
    
    // 辅助函数：移除 URL 中的 width 参数用于比较
    function removeWidthParam(url) {
      if (!url) return url;
      
      // 先规范化 URL
      const normalized = normalizeUrl(url);
      
      // 尝试提取路径和查询参数
      let pathAndQuery = getPathAndQuery(normalized);
      
      // 如果提取失败，直接对规范化后的 URL 进行处理
      if (!pathAndQuery || pathAndQuery === normalized) {
        pathAndQuery = normalized;
      }
      
      // 移除 width 参数（处理 ?width= 和 &width= 两种情况）
      let cleaned = pathAndQuery.replace(/[?&]width=[^&]*/gi, '');
      
      // 清理多余的 ? 和 &
      cleaned = cleaned.replace(/\?$/, '').replace(/&$/, '');
      // 如果移除 width 后只剩下 ?，也移除它
      cleaned = cleaned.replace(/\?&/g, '&').replace(/^\?/, '');
      
      return cleaned;
    }
    
    // 辅助函数：比较两个 URL（忽略 width 参数、域名和协议）
    function urlMatchesIgnoreWidth(url1, url2) {
      const cleanUrl1 = removeWidthParam(url1);
      const cleanUrl2 = removeWidthParam(url2);
      
      // 精确匹配
      if (cleanUrl1 === cleanUrl2) return true;
      
      // 部分匹配（一个包含另一个）
      if (cleanUrl1 && cleanUrl2) {
        return cleanUrl1.includes(cleanUrl2) || cleanUrl2.includes(cleanUrl1);
      }
      
      return false;
    }
    
    // 查找所有 img 标签
    const images = document.querySelectorAll('img');
    
    images.forEach(img => {
      let imgSrc = img.src || img.getAttribute('src');
      
      if (imgSrc) {
        // 尝试精确匹配和部分匹配（忽略 width 参数）
        const matchedKey = Object.keys(IMAGE_REPLACE_MAP).find(key => {
          return urlMatchesIgnoreWidth(imgSrc, key);
        });

        if (matchedKey && IMAGE_REPLACE_MAP[matchedKey]) {
          // 检查是否已经替换过，避免重复处理
          if (!img.dataset.replaced) {
            img.dataset.replaced = 'true';
            
            // 先清空原图片地址，阻止加载
            img.src = '';
            img.removeAttribute('src');
            if (img.dataset.src) {
              img.dataset.src = '';
              img.removeAttribute('data-src');
            }
            if (img.srcset) {
              img.srcset = '';
              img.removeAttribute('srcset');
            }
            
            // 使用 requestAnimationFrame 确保在下一帧设置新地址
            requestAnimationFrame(function() {
              img.src = IMAGE_REPLACE_MAP[matchedKey];
              
              // 如果存在 data-src（懒加载），也更新
              if (img.dataset.src !== undefined) {
                const dataSrc = img.getAttribute('data-src') || '';
                if (dataSrc) {
                  const dataMatchedKey = Object.keys(IMAGE_REPLACE_MAP).find(key => {
                    return urlMatchesIgnoreWidth(dataSrc, key);
                  });
                  if (dataMatchedKey && IMAGE_REPLACE_MAP[dataMatchedKey]) {
                    img.dataset.src = IMAGE_REPLACE_MAP[dataMatchedKey];
                  }
                }
              }
              
              // 如果存在 srcset，也更新
              const originalSrcset = img.getAttribute('srcset') || '';
              if (originalSrcset) {
                // srcset 格式：url1 width1, url2 width2, ...
                const srcsetParts = originalSrcset.split(',').map(part => part.trim());
                const newSrcsetParts = srcsetParts.map(part => {
                  // 分离 URL 和描述符（如 "url 2x" 或 "url 100w"）
                  const match = part.match(/^(.+?)(\s+\d+[wx]|\s+\d+\.\d+x)?$/);
                  if (match) {
                    const url = match[1].trim();
                    const descriptor = match[2] || '';
                    
                    // 检查这个 URL 是否匹配配置中的任何一个
                    const srcsetMatchedKey = Object.keys(IMAGE_REPLACE_MAP).find(key => {
                      return urlMatchesIgnoreWidth(url, key);
                    });
                    
                    if (srcsetMatchedKey && IMAGE_REPLACE_MAP[srcsetMatchedKey]) {
                      return IMAGE_REPLACE_MAP[srcsetMatchedKey] + descriptor;
                    }
                  }
                  return part;
                });
                img.srcset = newSrcsetParts.join(', ');
              }
            });
          }
        }
      }
    });

    // 查找所有 background-image 样式中的图片
    const elementsWithBg = document.querySelectorAll('[style*="background-image"], [style*="backgroundImage"]');
    
    elementsWithBg.forEach(element => {
      const style = element.getAttribute('style') || '';
      const bgImageMatch = style.match(/url\(['"]?([^'")]+)['"]?\)/);
      
      if (bgImageMatch) {
        const bgImageUrl = bgImageMatch[1];
        const matchedKey = Object.keys(IMAGE_REPLACE_MAP).find(key => {
          return urlMatchesIgnoreWidth(bgImageUrl, key);
        });

        if (matchedKey && IMAGE_REPLACE_MAP[matchedKey] && !element.dataset.bgReplaced) {
          element.dataset.bgReplaced = 'true';
          const newUrl = IMAGE_REPLACE_MAP[matchedKey];
          element.style.backgroundImage = style.replace(bgImageMatch[0], `url(${newUrl})`);
        }
      }
    });

    // 查找所有通过 CSS 类或 data 属性设置的背景图片
    const elementsWithDataBg = document.querySelectorAll('[data-bg], [data-background]');
    
    elementsWithDataBg.forEach(element => {
      const bgUrl = element.dataset.bg || element.dataset.background;
      if (bgUrl) {
        const matchedKey = Object.keys(IMAGE_REPLACE_MAP).find(key => {
          return urlMatchesIgnoreWidth(bgUrl, key);
        });

        if (matchedKey && IMAGE_REPLACE_MAP[matchedKey] && !element.dataset.dataBgReplaced) {
          element.dataset.dataBgReplaced = 'true';
          if (element.dataset.bg) {
            element.dataset.bg = IMAGE_REPLACE_MAP[matchedKey];
          }
          if (element.dataset.background) {
            element.dataset.background = IMAGE_REPLACE_MAP[matchedKey];
          }
        }
      }
    });
  }

  /**
   * 立即处理单个元素（不等待批量处理）
   */
  function processElementImmediately(element) {
    if (!element || element.dataset.processed) return;
    
    // 标记为已处理，避免重复
    element.dataset.processed = 'true';
    
    // 如果是图片，立即处理
    if (element.tagName === 'IMG') {
      const imgSrc = element.src || element.getAttribute('src');
      if (imgSrc) {
        // 使用图片替换逻辑
        const matchedKey = Object.keys(IMAGE_REPLACE_MAP).find(key => {
          // 需要访问 replaceImages 中的辅助函数，所以直接在这里实现匹配逻辑
          function normalizeUrl(url) {
            if (!url) return url;
            url = url.replace(/&amp;/g, '&');
            if (url.startsWith('//')) {
              url = 'https:' + url;
            }
            return url;
          }
          
          function getPathAndQuery(url) {
            if (!url) return url;
            try {
              const normalized = normalizeUrl(url);
              const urlObj = new URL(normalized);
              return urlObj.pathname + urlObj.search;
            } catch (e) {
              const normalized = normalizeUrl(url);
              const match = normalized.match(/\/\/[^\/]+(\/.*)/);
              if (match) return match[1];
              if (normalized.startsWith('/')) return normalized;
              return normalized;
            }
          }
          
          function removeWidthParam(url) {
            if (!url) return url;
            const normalized = normalizeUrl(url);
            let pathAndQuery = getPathAndQuery(normalized);
            if (!pathAndQuery || pathAndQuery === normalized) {
              pathAndQuery = normalized;
            }
            let cleaned = pathAndQuery.replace(/[?&]width=[^&]*/gi, '');
            cleaned = cleaned.replace(/\?$/, '').replace(/&$/, '');
            cleaned = cleaned.replace(/\?&/g, '&').replace(/^\?/, '');
            return cleaned;
          }
          
          function urlMatchesIgnoreWidth(url1, url2) {
            const cleanUrl1 = removeWidthParam(url1);
            const cleanUrl2 = removeWidthParam(url2);
            if (cleanUrl1 === cleanUrl2) return true;
            if (cleanUrl1 && cleanUrl2) {
              return cleanUrl1.includes(cleanUrl2) || cleanUrl2.includes(cleanUrl1);
            }
            return false;
          }
          
          return urlMatchesIgnoreWidth(imgSrc, key);
        });
        
        if (matchedKey && IMAGE_REPLACE_MAP[matchedKey]) {
          // 先清空原图片地址，阻止加载
          element.src = '';
          element.removeAttribute('src');
          if (element.dataset.src) {
            element.dataset.src = '';
            element.removeAttribute('data-src');
          }
          // 清空 srcset
          if (element.srcset) {
            element.srcset = '';
            element.removeAttribute('srcset');
          }
          // 使用 requestAnimationFrame 确保在下一帧设置新地址
          requestAnimationFrame(function() {
            element.src = IMAGE_REPLACE_MAP[matchedKey];
            if (element.dataset.src !== undefined) {
              element.dataset.src = IMAGE_REPLACE_MAP[matchedKey];
            }
          });
        }
      }
    }
    
    // 如果是视频，立即处理
    if (element.tagName === 'VIDEO') {
      let videoUrl = element.src;
      if (!videoUrl) {
        const source = element.querySelector('source');
        if (source) {
          videoUrl = source.src;
        }
      }
      
      if (videoUrl) {
        const matchedKey = Object.keys(VIDEO_COVER_MAP).find(key => {
          return videoUrl.includes(key) || key.includes(videoUrl);
        });
        
        if (matchedKey && VIDEO_COVER_MAP[matchedKey]) {
          // 先清空视频地址，阻止加载
          element.src = '';
          element.removeAttribute('src');
          const sources = element.querySelectorAll('source');
          sources.forEach(source => {
            source.src = '';
            source.removeAttribute('src');
          });
          
          const videoContainer = element.closest('.my-video-container');
          if (videoContainer) {
            const videoCover = videoContainer.querySelector('.video-cover');
            if (videoCover && !videoCover.dataset.replaced) {
              videoCover.dataset.replaced = 'true';
              videoCover.removeAttribute('onclick');
              videoCover.style.cursor = 'default';
              videoCover.style.pointerEvents = 'none';
              const playButton = videoCover.querySelector('.video-play-div');
              if (playButton) {
                playButton.style.display = 'none';
              }
              const coverImage = videoCover.querySelector('.cover-image');
              if (coverImage) {
                // 先清空原图片
                coverImage.src = '';
                coverImage.removeAttribute('src');
                requestAnimationFrame(function() {
                  coverImage.src = VIDEO_COVER_MAP[matchedKey];
                });
              }
            }
          } else if (element.parentNode) {
            // 立即替换为图片
            element.dataset.replaced = 'true';
            const newImg = document.createElement('img');
            newImg.src = VIDEO_COVER_MAP[matchedKey];
            newImg.alt = element.getAttribute('alt') || 'video cover';
            if (element.className) newImg.className = element.className;
            if (element.id) newImg.id = element.id;
            if (element.style.cssText) newImg.style.cssText = element.style.cssText;
            newImg.style.width = element.style.width || '100%';
            newImg.style.height = element.style.height || 'auto';
            newImg.style.objectFit = 'cover';
            newImg.style.display = element.style.display || 'block';
            element.parentNode.replaceChild(newImg, element);
          }
        }
      }
    }
    
    // 如果是 iframe，立即处理
    if (element.tagName === 'IFRAME') {
      const iframeSrc = element.src || element.getAttribute('src') || '';
      if (iframeSrc && (iframeSrc.includes('video') || iframeSrc.includes('.mp4') || 
          iframeSrc.includes('.mov') || iframeSrc.includes('cdn.shopify.com/videos'))) {
        function normalizeUrl(url) {
          if (!url) return url;
          url = url.replace(/&amp;/g, '&');
          if (url.startsWith('//')) {
            url = 'https:' + url;
          }
          return url;
        }
        
        function getBaseUrl(url) {
          try {
            const urlObj = new URL(normalizeUrl(url));
            return urlObj.origin + urlObj.pathname;
          } catch (e) {
            const parts = url.split('?')[0].split('#')[0];
            return parts;
          }
        }
        
        function urlMatches(url1, url2) {
          const base1 = getBaseUrl(url1);
          const base2 = getBaseUrl(url2);
          return base1 === base2 || base1.includes(base2) || base2.includes(base1);
        }
        
        const matchedKey = Object.keys(VIDEO_COVER_MAP).find(key => {
          return urlMatches(iframeSrc, key);
        });
        
        if (matchedKey && VIDEO_COVER_MAP[matchedKey] && element.parentNode) {
          // 先清空 iframe src，阻止加载
          element.src = '';
          element.removeAttribute('src');
          
          element.dataset.replaced = 'true';
          const newImg = document.createElement('img');
          newImg.src = VIDEO_COVER_MAP[matchedKey];
          newImg.alt = element.getAttribute('title') || 'video cover';
          if (element.className) newImg.className = element.className;
          if (element.id) newImg.id = element.id;
          if (element.style.cssText) {
            const styleText = element.style.cssText
              .replace(/background-image[^;]*;?/gi, '')
              .replace(/background-size[^;]*;?/gi, '')
              .replace(/background-position[^;]*;?/gi, '');
            if (styleText.trim()) {
              newImg.style.cssText = styleText;
            }
          }
          newImg.style.width = element.style.width || element.getAttribute('width') || '100%';
          newImg.style.height = element.style.height || element.getAttribute('height') || 'auto';
          newImg.style.objectFit = 'cover';
          newImg.style.display = element.style.display || 'block';
          if (element.getAttribute('title')) {
            newImg.setAttribute('title', element.getAttribute('title'));
          }
          element.parentNode.replaceChild(newImg, element);
        }
      }
    }
  }

  /**
   * 执行所有替换操作
   */
  function processMedia() {
    replaceVideoCovers();
    replaceImages();
  }

  /**
   * 为 iframe 添加加载监听器
   */
  function addIframeLoadListeners() {
    const iframes = document.querySelectorAll('iframe:not([data-load-listener])');
    iframes.forEach(iframe => {
      iframe.dataset.loadListener = 'true';
      iframe.addEventListener('load', function() {
        // iframe 加载完成后，延迟处理以确保 src 已设置
        setTimeout(function() {
          replaceVideoCovers();
        }, 100);
      });
      // 如果 iframe 已经加载完成，立即检查
      if (iframe.contentDocument || iframe.contentWindow) {
        setTimeout(function() {
          replaceVideoCovers();
        }, 100);
      }
    });
  }

  /**
   * 初始化 - 在页面加载时执行
   */
  function init() {
    // 立即执行一次
    processMedia();
    
    // 为现有 iframe 添加加载监听器
    addIframeLoadListeners();

    // 使用 MutationObserver 监听 DOM 变化（用于动态加载的内容）
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // 立即处理新添加的元素，不等待批量处理
              if (node.tagName === 'IMG' || node.tagName === 'VIDEO' || node.tagName === 'IFRAME') {
                processElementImmediately(node);
              }
              
              // 检查子元素
              if (node.tagName === 'IMG' || node.tagName === 'VIDEO' || node.tagName === 'IFRAME' ||
                  node.classList?.contains('my-video-container') ||
                  node.querySelector('video') || node.querySelector('img') ||
                  node.querySelector('iframe') || node.querySelector('.my-video-container')) {
                // 立即处理所有相关元素
                if (node.tagName === 'IMG' || node.tagName === 'VIDEO' || node.tagName === 'IFRAME') {
                  processElementImmediately(node);
                }
                const videos = node.querySelectorAll('video');
                videos.forEach(v => processElementImmediately(v));
                const images = node.querySelectorAll('img');
                images.forEach(img => processElementImmediately(img));
                const iframes = node.querySelectorAll('iframe');
                iframes.forEach(iframe => processElementImmediately(iframe));
                
                // 延迟批量处理作为备用
                setTimeout(processMedia, 50);
                addIframeLoadListeners();
              }
            }
          });
        }
      });
    });

    // 开始观察（如果 body 存在）
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'data-src']
      });
    } else {
      // 如果 body 还不存在，等待它创建
      const bodyObserver = new MutationObserver(function(mutations, obs) {
        if (document.body) {
          obs.disconnect();
          observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['src', 'data-src']
          });
        }
      });
      bodyObserver.observe(document.documentElement, {
        childList: true
      });
    }
  }

  // ========== 事件监听 ==========

  // 立即开始处理，不等待 DOMContentLoaded
  // 这样可以更早地拦截资源加载
  if (document.readyState === 'loading') {
    // 如果还在加载，立即开始监听
    if (document.documentElement) {
      const earlyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.tagName === 'IMG' || node.tagName === 'VIDEO' || node.tagName === 'IFRAME')) {
              processElementImmediately(node);
            }
          });
        });
      });
      earlyObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
    
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM 已经加载完成，直接执行
    init();
  }
  
  // 使用 requestAnimationFrame 立即执行一次，确保在渲染前处理
  if (typeof requestAnimationFrame !== 'undefined') {
    requestAnimationFrame(function() {
      processMedia();
    });
  }

  // 页面完全加载后再次执行（处理懒加载的内容）
  window.addEventListener('load', function() {
    setTimeout(processMedia, 500);
    // 再次延迟执行，确保所有 iframe 都已加载
    setTimeout(processMedia, 1500);
  });


  // Shopify 页面导航事件（如果使用了 AJAX 导航）
  document.addEventListener('shopify:section:load', processMedia);
  document.addEventListener('shopify:section:reorder', processMedia);

  // 如果使用了 Turbolinks 或其他 AJAX 导航库
  document.addEventListener('turbolinks:load', processMedia);
  document.addEventListener('pjax:end', processMedia);

  // 暴露全局函数，方便手动调用
  window.MediaReplacer = {
    process: processMedia,
    replaceVideoCovers: replaceVideoCovers,
    replaceImages: replaceImages
  };

})();

